import React from 'react';
import './WhyChooseUs.css';

export default function WhyChooseUs() {
  return (
    <section className="why-choose-us-section section-padding" id="why-choose-us">
      <div className="container">
        <div className="why-seller-grid">
          {/* Left Column: Heading and cards */}
          <div className="why-seller-left">
            <div className="why-seller-header">
              <h2 className="why-seller-title">Why Sellers Love <span className="why-seller-blue">Haatza?</span></h2>
              <p className="why-seller-subtitle">
                All the benefits that come with selling on Haatza are designed to help you sell more, and make it easier to grow your business.
              </p>
            </div>

            <div className="why-seller-cards">
              {/* Card 1 */}
              <div className="seller-love-card">
                <div className="love-card-header">
                  <div className="love-icon-box commission-bg">
                    <img src="https://static.wixstatic.com/media/fe689e_2378ac6785324d6a87177ac4caf8f209~mv2.jpg/v1/fill/w_86,h_64,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-01-22%20at%209_39_edited.jpg" alt="0% Commission Fee" className="love-card-img-icon" />
                  </div>
                  <h3 className="love-card-title">0% Commission Fee</h3>
                </div>
                <p className="love-card-text">
                  Suppliers selling on Haatza keep 100% of their profit by not paying any commission.
                </p>
              </div>

              {/* Card 2 */}
              <div className="seller-love-card">
                <div className="love-card-header">
                  <div className="love-icon-box penalty-bg">
                    <img src="https://static.wixstatic.com/media/fe689e_ff13d5ee9bf94121ace155d8b35f59a5~mv2.jpg/v1/fill/w_67,h_66,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-01-22%20at%209_38_edited.jpg" alt="Zero Penalty Charges" className="love-card-img-icon" />
                  </div>
                  <h3 className="love-card-title">Zero Penalty Charges</h3>
                </div>
                <p className="love-card-text">
                  Sell online without the fear of order cancellation charges with zero penalty for late dispatch or order cancellations.
                </p>
              </div>

              {/* Card 3 */}
              <div className="seller-love-card">
                <div className="love-card-header">
                  <div className="love-icon-box growth-bg">
                    <img src="https://static.wixstatic.com/media/fe689e_4cfc4802e14e41788b16b482383ba722~mv2.png/v1/fill/w_80,h_66,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-01-08%20at%207_edited.png" alt="Growth for Every Supplier" className="love-card-img-icon" />
                  </div>
                  <h3 className="love-card-title">Growth for Every Supplier</h3>
                </div>
                <p className="love-card-text">
                  From small to large and unbranded to branded, and now open for Sellers who don't have a Regular GSTIN too, Haatza fuels growth for all suppliers.
                </p>
              </div>

              {/* Card 4 */}
              <div className="seller-love-card">
                <div className="love-card-header">
                  <div className="love-icon-box ease-bg">
                    <img src="https://static.wixstatic.com/media/fe689e_001b74395f754eceb1daba58582d901a~mv2.png/v1/fill/w_64,h_66,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-01-08%20at%207_edited.png" alt="Ease of Doing Business" className="love-card-img-icon" />
                  </div>
                  <h3 className="love-card-title">Ease of Doing Business</h3>
                </div>
                <ul className="love-card-list">
                  <li>Easy Product Listing</li>
                  <li>Lowest Cost Shipping</li>
                  <li>7-Day Payment Cycle from the delivery date</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Right Column: Delivery Boy Image */}
          <div className="why-seller-visual">
            <div className="seller-image-wrapper">
              <img 
                src="https://static.wixstatic.com/media/73d0ef_f00f1816fca047c5a3775a455475f1a5~mv2.jpg/v1/fill/w_450,h_675,fp_0.42_0.05,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/cdsds_edited.jpg" 
                alt="Haatza Delivery Representative" 
                className="seller-delivery-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
